import { createEntityAdapter } from '@reduxjs/toolkit';

const dspsAdapter = createEntityAdapter();

export default dspsAdapter;
